import * as React from 'react'
import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state'
import Dashboard from '@chegg-wt/core/components/Layouts/Dashboard'
import withApollo from '@chegg-wt/core/api/graphApi'
import { UseShowTourHandler, useShowTour } from '@chegg-wt/core/hooks/useShowTour'
import { getUpsellCopy } from '@chegg-wt/core/components/Dashboard/helpers'

import {
  getDashboardTourSeen,
  setDashboardTourSeen,
} from '@chegg-wt/core/utils/localStorage'
import { getCitationsExperience } from '@chegg-wt/core/utils/citationFlow'
import { isProSelector } from '@chegg-wt/core/state/user/selectors'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { upsellCopy } from '../../copy/Dashboard'

interface EBDashboardProps {
  isPro: boolean
}

const EBDashboard: React.FC<EBDashboardProps> = ({ isPro }) => {
  const citationsExperience = getCitationsExperience(isPro, true)
  const tourHandler: UseShowTourHandler = useShowTour({
    isActive: !getDashboardTourSeen(),
    onComplete: setDashboardTourSeen,
  })
  useOnUnloadTimeOnPage()

  return (
    <Dashboard
      upsellCopy={getUpsellCopy(upsellCopy)}
      citationsExperience={citationsExperience}
      tourHandler={tourHandler}
    />
  )
}

const mapStateToProps = (state: AppState) => ({
  isPro: isProSelector(state),
})

export default withApollo()(connect(mapStateToProps)(EBDashboard))
